import {literalUnion} from '@raison/io-ts-tools';
import {type} from 'arktype';

export type UserStatus = (typeof UserStatuses)[number];

export const UserStatuses = [
    'draft',
    'on_board',
    'temp_blocked',
    'blocked',
    'kyc_start',
    'kyc_finish',
    'kyc_completed',
    'moderating',
    'refused',
    'stuck',
    'doc_expired',
] as const;

export const UserStatusArktype = type.enumerated(...UserStatuses);
export const UserStatusIoTs = literalUnion(...UserStatuses);
